'use client';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoImg from 'eco-design/base/eco-img';
import { useRef, useState } from 'react';
import { langTxt } from '../../../lang';
import MicrosoftChatA from '../MicrosoftChat';
import { openCustonChatList } from '../MicrosoftChat/config';
import { useVerticalRoll } from '../useVerticalRoll';
import IconArrow from './IconArrow';

import useOpenAiChat from '@elem/compPage/chat/core/components/chat-icon/useOpenAiChat';
import './index.scss';
export default function WebClientA({ payloadData, payloadReady, microsoftChatItemA = {} }: any) {
    const chatRef = useRef<any>({});
    const microsoftChatItemB = microsoftChatItemA || {};
    const { locale } = getLocal();
    const lang = langTxt[locale] || langTxt['us'];
    const { handleOpenChat } = useOpenAiChat();
    const [firstInit, setFirstInit] = useState<boolean>(false);
    const { contentRef } = useVerticalRoll({
        itemHeight: 22,
        length: 3,
    });

    // 打开
    const openHandleA = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'get_support',
            button_name: 'Support Chat Icon',
            __btn_id1: `MicrosoftChat`,
            __btn_id2: 'MicrosoftChat-icon',
            __btn_type: 'common',
        });
        setFirstInit(true);
        if (openCustonChatList.includes(locale)) {
            handleOpenChat();
            return;
        }
        typeof chatRef.current?.open === 'function' && chatRef.current?.open();

        // EcoDesignEventsBus.emit('BarRBottom-ItemMicrosoftChat-open');
    };
    const listA1 = microsoftChatItemB.questionExampleList || [];

    return (
        <section className={'widgets-micro-chat-bottom'} onClick={openHandleA}>
            <div className="chat-box">
                <div className="chat-icon">
                    <EcoImg pc={microsoftChatItemB.widgetIcon}></EcoImg>
                </div>
                <div className="chat-name">{lang['ask']}</div>
                {!firstInit && (
                    <>
                        <div className="chat-question-box" style={{ height: '22px' }}>
                            <div className="roll-content" ref={contentRef}>
                                {listA1.map((item: string, index: number) => (
                                    <div className="question-item" key={index}>
                                        {item}
                                    </div>
                                ))}
                                <div className="question-item" key={listA1.length + 1}>
                                    {listA1[0]}
                                </div>
                            </div>
                        </div>
                        <div className="chat-arrow">
                            <IconArrow />
                        </div>
                    </>
                )}
            </div>
            {payloadReady && <MicrosoftChatA payloadData={payloadData} onReady={(chatApi) => (chatRef.current = chatApi)} />}
        </section>
    );
}
